export const DragModeList = [
    {
        name: 'افزودن',
        value: 'add'
    },
    {
        name: 'حذف',
        value: 'remove'
    }
]